var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisilyLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 55,
    viewBox: "0 0 120 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_799_2982)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.9728 20.9817C48.7525 18.6473 46.4402 17.8655 44.304 18.7519C41.331 19.9852 36.8825 23.8501 35.5776 25.2981C28.9709 32.6811 27.7597 40.0256 27.1706 46.1808C26.5815 52.3361 36.1612 52.7325 37.1192 46.6488C40.7529 23.6079 49.4022 25.4633 48.9728 20.9817Z",
    fill: "url(#paint0_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.842 45.3769C36.6082 35.6077 34.105 26.0269 29.5305 17.3919C26.7919 12.0334 23.0544 7.24764 18.5193 3.29207C11.9126 -2.69802 0.494012 -0.512302 0.0260361 9.83822C-0.254749 16.0816 5.21231 18.6086 8.16331 20.475C11.8354 22.7321 15.1575 25.5143 18.0238 28.7334C22.5747 33.8281 25.664 40.058 26.9649 46.7643C28.0715 53.0572 37.9211 52.0441 36.842 45.3769Z",
    fill: "url(#paint1_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3096 13.6699C52.634 13.6688 51.9733 13.8683 51.4111 14.2429C50.8489 14.6176 50.4106 15.1506 50.1515 15.7746C49.8925 16.3985 49.8244 17.0853 49.9559 17.748C50.0875 18.4106 50.4127 19.0194 50.8904 19.4971C51.3681 19.9748 51.9769 20.3 52.6395 20.4315C53.3022 20.5631 53.989 20.495 54.6129 20.236C55.2369 19.9769 55.7699 19.5386 56.1446 18.9764C56.5192 18.4142 56.7187 17.7535 56.7176 17.0779C56.7176 16.174 56.3585 15.3072 55.7194 14.6681C55.0803 14.029 54.2134 13.6699 53.3096 13.6699Z",
    fill: "url(#paint2_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1631 13.6699C83.4875 13.6688 82.8268 13.8683 82.2646 14.2429C81.7024 14.6176 81.2641 15.1506 81.005 15.7746C80.746 16.3985 80.6779 17.0853 80.8095 17.748C80.941 18.4106 81.2662 19.0194 81.7439 19.4971C82.2216 19.9748 82.8304 20.3 83.493 20.4315C84.1557 20.5631 84.8425 20.495 85.4664 20.236C86.0904 19.9769 86.6234 19.5386 86.9981 18.9764C87.3728 18.4142 87.5722 17.7535 87.5711 17.0779C87.5711 16.174 87.212 15.3072 86.5729 14.6681C85.9338 14.029 85.067 13.6699 84.1631 13.6699Z",
    fill: "url(#paint3_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.1689 22.7439C52.4807 22.7439 51.8206 23.0169 51.3334 23.503C50.8462 23.9892 50.5718 24.6488 50.5703 25.337V45.0058C50.5703 45.3823 50.8756 45.6875 51.2521 45.6872C52.3861 45.6862 54.01 45.6834 55.1621 45.6824C55.5391 45.6821 55.8442 45.3761 55.8436 44.9991L55.8116 25.3315C55.8088 24.9878 55.7381 24.6482 55.6035 24.3319C55.469 24.0157 55.2734 23.7291 55.0279 23.4887C54.7823 23.2483 54.4917 23.0587 54.1727 22.9309C53.8537 22.8031 53.5126 22.7395 53.1689 22.7439Z",
    fill: "url(#paint4_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.8142 33.81C74.1092 33.3212 73.338 32.9356 72.5239 32.6648C71.7146 32.3675 70.9273 32.1142 70.1785 31.8995C69.4298 31.6848 68.6259 31.4701 67.9322 31.2388C67.3428 31.0203 66.7994 30.6936 66.3301 30.2754C66.1411 30.0754 65.9948 29.8389 65.9001 29.5805C65.8054 29.3221 65.7644 29.0471 65.7796 28.7723C65.7637 28.4321 65.8475 28.0946 66.0205 27.8012C66.1936 27.5078 66.4485 27.2713 66.754 27.1206C67.6189 26.6688 68.5868 26.4505 69.5619 26.4875C70.6428 26.463 71.7164 26.6695 72.7111 27.0931L73.3553 27.3794C73.6578 27.5183 73.9906 27.5785 74.3226 27.5544C74.6547 27.5304 74.9753 27.4228 75.2547 27.2418C75.5366 27.0603 75.7686 26.811 75.9292 26.5166C76.0898 26.2223 76.174 25.8924 76.1741 25.5571C76.1726 25.1024 76.0377 24.6582 75.7862 24.2795C75.5347 23.9008 75.1776 23.6042 74.7592 23.4264C74.1811 23.1786 73.592 22.9474 73.0029 22.7437C71.7333 22.3339 70.406 22.1313 69.0719 22.1436C67.7143 22.1539 66.369 22.4017 65.0969 22.8758C63.8036 23.3203 62.6533 24.1036 61.766 25.1441C60.821 26.3325 60.338 27.8227 60.4061 29.3394C60.338 30.6744 60.7263 31.9928 61.5072 33.0777C62.2265 33.9805 63.1516 34.6978 64.205 35.1698C65.2528 35.6057 66.3311 35.9646 67.4312 36.2434C68.202 36.5132 68.9453 36.794 69.6665 37.0472C70.278 37.2368 70.8414 37.556 71.3182 37.9832C71.5242 38.1494 71.6873 38.3627 71.7936 38.6051C71.9 38.8475 71.9465 39.112 71.9293 39.3761C71.9317 39.7354 71.8461 40.0897 71.6801 40.4083C71.5141 40.7269 71.2726 41.0001 70.9768 41.204C70.113 41.7261 69.1103 41.972 68.1029 41.9087C66.7894 41.936 65.4823 41.7175 64.249 41.2645C63.9517 41.1379 63.6544 41.0003 63.3516 40.8516C63.047 40.7032 62.7098 40.6347 62.3715 40.6524C62.0331 40.6702 61.7049 40.7737 61.4176 40.9531C61.1302 41.1326 60.8932 41.3821 60.7288 41.6783C60.5644 41.9745 60.478 42.3077 60.4777 42.6464V42.8501C60.475 43.3036 60.607 43.7476 60.857 44.1259C61.1069 44.5042 61.4635 44.7998 61.8816 44.9753C62.5496 45.2602 63.2334 45.5065 63.9297 45.7131C65.2949 46.0708 66.7028 46.2394 68.1139 46.2141C69.5877 46.2195 71.0514 45.9718 72.4413 45.4818C73.7744 45.0254 74.9569 44.2123 75.8603 43.1309C76.8324 41.9207 77.3314 40.3984 77.2642 38.8476C77.3065 37.7639 77.0655 36.688 76.565 35.7259C76.1503 34.9513 75.5485 34.2926 74.8142 33.81Z",
    fill: "url(#paint5_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.1205 22.7439C83.4327 22.7439 82.7732 23.0507 82.2868 23.5968C81.8005 24.1429 81.5273 24.8835 81.5273 25.6558V44.7577C81.5273 45.1342 81.8324 45.4395 82.209 45.4392C83.4943 45.4383 85.1064 45.4352 86.1187 45.4339C86.4958 45.4334 86.8011 45.1272 86.8004 44.7502L86.7632 25.6496C86.7603 25.2637 86.6896 24.8823 86.5551 24.5272C86.4206 24.172 86.2249 23.8503 85.9794 23.5803C85.7338 23.3103 85.4432 23.0974 85.1242 22.9539C84.8052 22.8104 84.4641 22.739 84.1205 22.7439Z",
    fill: "url(#paint6_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3431 14.1328C94.0026 14.1328 93.6654 14.2057 93.3508 14.3472C93.0362 14.4887 92.7503 14.6961 92.5095 14.9576C92.2687 15.2191 92.0777 15.5296 91.9474 15.8713C91.8171 16.2129 91.75 16.5791 91.75 16.949V44.7574C91.75 45.1339 92.0543 45.4392 92.4308 45.4392C93.4851 45.4392 95.1526 45.4392 96.2603 45.4392C96.6368 45.4392 96.9418 45.1339 96.9418 44.7574V16.949C96.9403 16.2015 96.6659 15.4852 96.1787 14.9573C95.6915 14.4293 95.0314 14.1328 94.3431 14.1328Z",
    fill: "url(#paint7_radial_799_2982)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.488 23.0626C119.267 22.7805 118.984 22.5525 118.662 22.396C118.339 22.2396 117.985 22.1587 117.627 22.1597C116.955 22.1663 116.307 22.4139 115.802 22.8574C115.297 23.3009 114.968 23.911 114.874 24.5766C114.15 29.6673 112.912 34.6717 111.18 39.5133C109.873 34.258 107.971 29.1691 105.509 24.3454C105.239 23.8214 104.829 23.3822 104.325 23.0762C103.82 22.7702 103.242 22.6093 102.652 22.6111C102.273 22.6131 101.9 22.7129 101.571 22.901C101.242 23.0891 100.967 23.359 100.772 23.6846C100.578 24.0102 100.471 24.3805 100.462 24.7596C100.452 25.1387 100.541 25.5137 100.719 25.8484C107.067 37.6359 108.119 44.5124 108.207 45.1676C107.919 46.3678 107.381 47.4935 106.627 48.4709C106.225 48.9453 105.777 49.3786 105.289 49.7647C104.796 50.1549 104.429 50.6813 104.234 51.2784C104.038 51.8755 104.022 52.5171 104.188 53.1232L104.458 53.0681L104.193 53.1342C104.276 53.4279 104.453 53.6864 104.697 53.8703C104.94 54.0542 105.237 54.1534 105.542 54.1527C105.626 54.1606 105.711 54.1606 105.796 54.1527C106.389 54.0413 106.966 53.8564 107.513 53.6021C108.597 53.0562 109.539 52.2666 110.266 51.2953C110.756 50.7062 115.144 45.0024 119.901 25.1327C119.997 24.7792 120.01 24.4083 119.938 24.0491C119.866 23.6899 119.712 23.3522 119.488 23.0626Z",
    fill: "url(#paint8_radial_799_2982)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.7588 44.876) scale(30.0385)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A78DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45B2EE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.795 8.65452) scale(52.6996)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6454D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3A78DD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4368 14.5233) scale(78.3612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4369 14.5233) scale(78.3612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4393 14.524) scale(78.3611)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4366 14.5238) scale(78.3612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4384 13.5136) scale(78.361 87.9941)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4371 14.5573) scale(78.3611 85.1)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_799_2982",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(56.4378 14.5234) scale(78.3612)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#45B2EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6454D6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_799_2982"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 54.142,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisilyLogo);
export default __webpack_public_path__ + "static/media/Visily-logo.fa0519589791e2e74512082b16c90379.svg";
export { ForwardRef as ReactComponent };